import { render, staticRenderFns } from "./remark.vue?vue&type=template&id=02e4ee61&scoped=true&"
import script from "./remark.vue?vue&type=script&lang=js&"
export * from "./remark.vue?vue&type=script&lang=js&"
import style0 from "./remark.vue?vue&type=style&index=0&id=02e4ee61&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e4ee61",
  null
  
)

export default component.exports